export enum AccountManagerDashboardAlertType {
    AllTiles = 0,
    NoteFollowUps = 1
}

export enum AccountManagerDashboardFollowupType {
    Today = 1,
    Overdue = 2,
    Completed = 3,
    Upcoming = 4
}

export enum AccountManagerFollowupType {
    Facility = 1,
    System = 2
}
